<template>
    <div class="profile_menu_wrap noselect">
        <div class="profile_menu_button" @click="toggleMenu">
            <!--
            <RadialProgressBar
                v-if="user.student_status==='full'"
                v-bind:progress="(user.schedule.count/user.schedule.max)*100">
                {{user.level}}
            </RadialProgressBar>
            <RadialProgressBar
                v-if="user.student_status==='trial'"
                v-bind:progress="isTrialLessonFinished?100:0">
                {{'P'}}
            </RadialProgressBar>
            -->
            <RadialProgressBar
                v-if="user.level>0"
                v-bind:progress="user.progress">
                {{user.level}}
            </RadialProgressBar>
            <RadialProgressBar
                v-else
                v-bind:progress="isTrialLessonFinished?user.progress:0">
                {{'P'}}
            </RadialProgressBar>
            <p class="profile_name">{{user.user_display_name}}</p>
            <div class="icon-chevron-down" v-if="!isOpenedMenu"></div>
            <div class="icon-chevron-up" v-if="isOpenedMenu"></div>
        </div>
        <transition name="bounce">
            <div class="profile_menu" v-if="isOpenedMenu">
                <div class="profile_info" v-if="user.student_status==='full'">
                    <div class="profile_info_text">
                        <span class="learning_level">Nivelul {{user.level}}</span>
                        <span class="learning_lessons">{{user.schedule.count}}/{{user.schedule.max}}</span>
                    </div>
                    <div class="progress">
                        <div :style="{width: ((user.schedule.count/user.schedule.max)*100)+'%'}"></div>
                    </div>
                </div>
                <div class="profile_info" v-if="user.student_status==='trial'">
                    <div class="profile_info_text">
                        <span class="learning_level">{{$t('strings.USER_LEVEL')}}</span>
                        <span class="learning_lessons">{{isTrialLessonFinished?1:0}}/1</span>
                    </div>
                    <div class="progress">
                        <div :style="{width: (isTrialLessonFinished?100:0)+'%'}"></div>
                    </div>
                </div>
                <div class="delimiter"></div>
                <div class="menu_items">
                    <a :href="url_prefix+'/profile/'">
                        <div class="item">
                            <div class="icon svg-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.71517 3.7012L8.79706 3.63542C8.92365 3.5157 8.99928 3.34805 9 3.17V3C9 1.34315 10.3431 0 12 0C13.6569 0 15 1.34315 15 3L15 3.08601C15.001 3.34508 15.1558 3.5788 15.4038 3.68514C15.6469 3.79243 15.9308 3.74095 16.1129 3.56289L16.3173 3.36764C16.8627 2.8894 17.5651 2.62343 18.295 2.62343C19.0912 2.62343 19.8548 2.93996 20.4167 3.5025C20.98 4.0652 21.2966 4.82877 21.2966 5.625C21.2966 6.42123 20.98 7.18479 20.4171 7.74711L20.3649 7.79926C20.1791 7.98922 20.1276 8.27314 20.2349 8.51623C20.2631 8.58031 20.2845 8.64699 20.2988 8.71517C20.4177 8.89041 20.6163 8.99914 20.83 9H21C22.6569 9 24 10.3431 24 12C24 13.6569 22.6569 15 21 15L20.914 15C20.6549 15.001 20.4212 15.1558 20.3149 15.4038C20.2076 15.6469 20.2591 15.9308 20.4371 16.1129L20.6324 16.3173C21.1106 16.8627 21.3766 17.5651 21.3766 18.295C21.3766 19.0912 21.06 19.8548 20.4975 20.4167C19.9348 20.98 19.1712 21.2966 18.375 21.2966C17.5788 21.2966 16.8152 20.98 16.2529 20.4171L16.2007 20.3649C16.0108 20.1791 15.7269 20.1276 15.4739 20.2391C15.2358 20.3412 15.081 20.5749 15.08 20.83V21C15.08 22.6569 13.7369 24 12.08 24C10.4231 24 9.08 22.6569 9.08 21L9.08027 20.9334C9.07403 20.6666 8.90531 20.4307 8.59623 20.3149C8.35314 20.2076 8.06922 20.2591 7.88711 20.4371L7.68274 20.6324C7.13731 21.1106 6.43488 21.3766 5.705 21.3766C4.90877 21.3766 4.14521 21.06 3.58329 20.4975C3.01996 19.9348 2.70343 19.1712 2.70343 18.375C2.70343 17.5788 3.01996 16.8152 3.58289 16.2529L3.63514 16.2007C3.82095 16.0108 3.87243 15.7269 3.76086 15.4739C3.6588 15.2358 3.42508 15.081 3.17 15.08H3C1.34315 15.08 0 13.7369 0 12.08C0 10.4231 1.34315 9.08 3 9.08L3.06662 9.08027C3.33344 9.07403 3.56934 8.90531 3.68514 8.59623C3.79243 8.35314 3.74095 8.06922 3.56289 7.88711L3.36764 7.68274C2.8894 7.13731 2.62343 6.43488 2.62343 5.705C2.62343 4.90877 2.93996 4.14521 3.5025 3.58329C4.0652 3.01996 4.82877 2.70343 5.625 2.70343C6.42123 2.70343 7.18479 3.01996 7.74711 3.58289L7.79926 3.63514C7.98922 3.82095 8.27314 3.87243 8.51623 3.76514L8.61416 3.72792L8.71517 3.7012ZM18.3285 9.12979L18.2729 8.95135C18.0278 8.05349 18.2718 7.0789 18.9429 6.39289L19.0033 6.3325C19.1911 6.14493 19.2966 5.89041 19.2966 5.625C19.2966 5.35959 19.1911 5.10507 19.0025 4.91671C18.8149 4.72894 18.5604 4.62343 18.295 4.62343C18.0296 4.62343 17.7751 4.72894 17.5871 4.91711L17.5193 4.98486C16.7448 5.74239 15.5873 5.95227 14.6061 5.51914C13.6353 5.10306 13.0042 4.1502 13 3.09V3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3L11 3.17399C10.9958 4.2302 10.3647 5.18306 9.39393 5.59914C9.30943 5.63536 9.22054 5.65966 9.12979 5.67154C8.18472 6.00284 7.12463 5.77296 6.39289 5.05711L6.3325 4.99671C6.14493 4.80894 5.89041 4.70343 5.625 4.70343C5.35959 4.70343 5.10507 4.80894 4.91671 4.9975C4.72894 5.18507 4.62343 5.43959 4.62343 5.705C4.62343 5.97041 4.72894 6.22493 4.91711 6.41289L4.98486 6.48073C5.69504 7.20675 5.92389 8.26949 5.60882 9.16785L5.46626 9.52187C5.04927 10.4451 4.13585 11.0558 3.09 11.08H3C2.44772 11.08 2 11.5277 2 12.08C2 12.6323 2.44772 13.08 3 13.08L3.17399 13.08C4.2302 13.0842 5.18306 13.7153 5.59486 14.6762C6.03227 15.6673 5.82239 16.8248 5.05711 17.6071L4.99671 17.6675C4.80894 17.8551 4.70343 18.1096 4.70343 18.375C4.70343 18.6404 4.80894 18.8949 4.9975 19.0833C5.18507 19.2711 5.43959 19.3766 5.705 19.3766C5.97041 19.3766 6.22493 19.2711 6.41289 19.0829L6.48073 19.0151C7.20675 18.305 8.26949 18.0761 9.16785 18.3912L9.52187 18.5337C10.4451 18.9507 11.0558 19.8641 11.08 20.91V21C11.08 21.5523 11.5277 22 12.08 22C12.6323 22 13.08 21.5523 13.08 21L13.08 20.826C13.0842 19.7698 13.7153 18.8169 14.6762 18.4051C15.6673 17.9677 16.8248 18.1776 17.6071 18.9429L17.6675 19.0033C17.8551 19.1911 18.1096 19.2966 18.375 19.2966C18.6404 19.2966 18.8949 19.1911 19.0833 19.0025C19.2711 18.8149 19.3766 18.5604 19.3766 18.295C19.3766 18.0296 19.2711 17.7751 19.0829 17.5871L19.0151 17.5193C18.2576 16.7448 18.0477 15.5873 18.4809 14.6061C18.8969 13.6353 19.8498 13.0042 20.91 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11L20.826 11C19.7698 10.9958 18.8169 10.3647 18.4009 9.39393C18.3767 9.3376 18.3579 9.27931 18.3445 9.21982L18.3285 9.12979ZM12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z" />
                                </svg>
                            </div>
                            <span class="item_text">{{$t('strings.BTN_PROFILE')}}</span>
                        </div>
                    </a>
                    <a :href="url_prefix+'/profile/referral'">
                        <div class="item focused">
                            <div class="icon svg-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M21.6067 5.25887C22.0733 4.69988 22.3594 3.95181 22.3594 3.13043C22.3594 1.40431 21.0977 0 19.5469 0C17.9961 0 16.7344 1.40431 16.7344 3.13043C16.7344 3.95181 17.0205 4.69988 17.487 5.25887C16.0658 6.08776 15.0938 7.7459 15.0938 9.65217V11.2174C15.0938 11.6496 15.4086 12 15.7969 12H23.2969C23.6852 12 24 11.6496 24 11.2174V9.65217C24 7.7459 23.028 6.08776 21.6067 5.25887ZM19.5469 1.56522C20.3223 1.56522 20.9531 2.26737 20.9531 3.13043C20.9531 3.9935 20.3223 4.69565 19.5469 4.69565C18.7715 4.69565 18.1406 3.9935 18.1406 3.13043C18.1406 2.26737 18.7715 1.56522 19.5469 1.56522ZM22.5938 10.4348H16.5V9.65217C16.5 7.78221 17.8668 6.26087 19.5469 6.26087C21.2269 6.26087 22.5938 7.78221 22.5938 9.65217V10.4348Z" fill="#CF0920"/>
                                    <path d="M8.90625 11.2174V9.65217C8.90625 7.7459 7.9342 6.08776 6.51295 5.25887C6.97955 4.69988 7.26562 3.95181 7.26562 3.13043C7.26562 1.40431 6.00394 0 4.45312 0C2.90231 0 1.64062 1.40431 1.64062 3.13043C1.64062 3.95181 1.9267 4.69988 2.3933 5.25887C0.972047 6.08776 0 7.7459 0 9.65217V11.2174C0 11.6496 0.314812 12 0.703125 12H8.20312C8.59144 12 8.90625 11.6496 8.90625 11.2174ZM4.45312 1.56522C5.22853 1.56522 5.85938 2.26737 5.85938 3.13043C5.85938 3.9935 5.22853 4.69565 4.45312 4.69565C3.67772 4.69565 3.04688 3.9935 3.04688 3.13043C3.04688 2.26737 3.67772 1.56522 4.45312 1.56522ZM7.5 10.4348H1.40625V9.65217C1.40625 7.78221 2.77308 6.26087 4.45312 6.26087C6.13317 6.26087 7.5 7.78221 7.5 9.65217V10.4348Z" fill="#CF0920"/>
                                    <path d="M20.044 14.3162C19.7694 14.0105 19.3243 14.0105 19.0497 14.3162L16.2372 17.4466C15.9626 17.7522 15.9626 18.2477 16.2372 18.5534C16.5118 18.859 16.9569 18.859 17.2315 18.5534L18.8438 16.7589V22.4347H5.15625V14.8695C5.15625 14.4373 4.84144 14.0869 4.45312 14.0869C4.06481 14.0869 3.75 14.4373 3.75 14.8695V23.2173C3.75 23.6496 4.06481 24 4.45312 24H19.5469C19.9352 24 20.25 23.6496 20.25 23.2173V16.7589L21.8622 18.5534C22.1368 18.859 22.582 18.859 22.8566 18.5534C23.1312 18.2477 23.1312 17.7522 22.8566 17.4466L20.044 14.3162Z" fill="#CF0920"/>
                                </svg>
                            </div>
                            <span class="item_text">Învață gratuit!</span>
                        </div>
                    </a>
                    <div class="item" @click="logOut">
                        <div class="icon icon-log-out"></div>
                        <span class="item_text">{{$t('login.BTN_SIGNOUT')}}</span>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="opacity">
            <div class="profile_menu_background" v-if="isOpenedMenu" @click="toggleMenu"></div>
        </transition>
    </div>
</template>

<script>
    import RadialProgressBar from '@/components/RadialProgressBar/RadialProgressBar.vue';
    import { mapGetters, mapActions } from 'vuex';
    import i18n from '@/i18n';

    export default {
        name: "ProfileMenu",
        components: {
            RadialProgressBar
        },
        data: function () {
            return {
                isOpenedMenu: false
            }
        },
        computed: {
            ...mapGetters({
                user: 'user/get',
            }),
            isTrialLessonFinished() {
                return this.user.is_trial_lesson_finished;
            },
            url_prefix(){
                return (i18n.locale=="ro"?"":"/"+i18n.locale);
            }
        },
        methods: {
            toggleMenu() {
                this.isOpenedMenu = !this.isOpenedMenu
            },
            logOut() {
                this.toggleMenu();
                this.$store.dispatch("user/logout")
            }
        },
        created() {

        },
    }
</script>

<style scoped lang="scss">

    .profile_menu_background {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(234, 237, 242, 0.9);
        z-index: 1000;
    }

    .profile_menu_wrap {
        position: relative;
        margin-left: 1.8rem;
    }

    .delimiter {
        background: #EAECF2;
        height: 2px;
    }

    .menu_items {
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        a{
            text-decoration: none;
        }
        .item{
            padding: 16px 12px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;

            .icon {
                margin-right: 12px;

                &:before {
                    font-size: 16px;
                    color: rgba(0, 0, 0, 0.65);
                    font-weight: bold;
                }
                &.svg-icon{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    &>svg{
                        width:16px;
                        fill:#595959;
                    }
                }
            }

            .item_text {
                font-family: FuturaPT;
                font-size: 16px;
                line-height: 20px;
                letter-spacing: 0.5px;
                color: #0B1022;
            }
            &:hover {
                background: #F0F3F8;

                .icon {
                    &:before {
                        color: #CF0920;
                    }
                    svg{
                        fill:#CF0920;
                    }
                }

                .item_text {
                    color: #CF0920;
                }
            }
            &.focused{
                .icon {
                    &:before {
                        color: #CF0920;
                    }
                    svg{
                        fill:#CF0920;
                    }
                }

                .item_text {
                    color: #CF0920;
                }
            }
        }
    }

    .profile_info {
        padding: 20px 16px;

        .profile_info_text {
            display: flex;
            justify-content: space-between;
            padding-bottom: 4px;

            .learning_level {
                font-family: FuturaPT;
                font-size: 16px;
                line-height: 20px;
                letter-spacing: 0.5px;
                color: #0B1022;
            }

            .learning_lessons {
                font-family: FuturaPT;
                font-size: 16px;
                line-height: 20px;
                text-align: right;
                letter-spacing: 0.5px;
                color: rgba(11, 16, 34, 0.3);
            }
        }

        .progress {
            background: #EAECF2;
            border-radius: 7.5px;
            width: 100%;
            height: 5px;

            div {
                background: #CF0920;
                border-radius: 7.5px;
                width: 0;
                height: 100%;
            }
        }
    }

    .profile_menu {
        background: #FFFFFF;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        z-index: 1001;
        position: absolute;
        width: 100%;
        top: calc(100% + 4px);
        overflow: hidden;
    }

    .profile_menu_button {
        background: #FFFFFF;
        border-radius: 2.4rem;
        display: flex;
        align-items: center;
        padding: 0.35rem 1.8rem 0.4rem 0.25rem;
        cursor: pointer;
        position: relative;
        z-index: 1001;
    }

    .profile_name {
        font-family: FuturaPT;
        font-size: 1.6rem;
        line-height: 1.2;
        letter-spacing: 0.05rem;
        color: rgba(11, 16, 34, 0.3);
        padding-right: 1rem;
        padding-left: 0.7rem;
    }

    .icon-chevron-down, .icon-chevron-up {
        &:before {
            font-size: 1.6rem;
            color: rgba(0, 0, 0, 0.65);
            font-weight: bold;
        }
    }

    .bounce-enter-active {
        animation: bounce-in .3s;
    }

    .bounce-leave-active {
        animation: bounce-in .3s reverse;
    }

    @keyframes bounce-in {
        0% {
        transform: scale(0);
        }
        50% {
        transform: scale(1.1);
        }
        100% {
        transform: scale(1);
        }
    }

    .opacity-enter-active {
        animation: opacity-in .3s;
    }

    .opacity-leave-active {
        animation: opacity-in .3s reverse;
    }

    @keyframes opacity-in {
        0% {
        opacity: 0;
        }
        100% {
        opacity: 1;
        }
    }
</style>